import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getToken } from '@/utils/auth'
import { pathMatcher } from '@/utils/index'
import { isWechatBrowser, getCodeFromUrl, wechatSilentAuth, clearAuthParams } from '@/utils/wxAuth'

const whiteList = ['/login', '/registry', '/', '/index', '/category', '/detail/**', '/diamondGoodsList/**', '/search/**', '/order/coupon']

/**
 * 校验手机号是否为合法的中国手机号
 * 静默授权后新用户的 mobile 被设置为会员ID（非手机号格式），
 * 用于判断用户是否已完成资料完善
 */
function isValidPhone(mobile) {
  if (!mobile) return false
  return /^1[3-9]\d{9}$/.test(mobile)
}

router.beforeEach(async(to, from, next) => {
  document.title = to.meta.title || '天津范儿·周末课程超市'

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      const needBind = sessionStorage.getItem('need_bind') === 'true'
      if (needBind) {
        next()
      } else {
        next({ path: '/' })
      }
    } else {
      const hasUserInfo = store.getters.id
      if (hasUserInfo) {
        // 已有用户信息时，检查手机号是否合法（防止绕过绑定页面）
        const mobile = store.getters.userInfo?.mobile
        if (!isValidPhone(mobile)) {
          sessionStorage.setItem('need_bind', 'true')
          next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
          return
        }
        next()
      } else {
        try {
          await store.dispatch('user/getInfo')
          // 获取用户信息成功后，检查手机号是否合法
          const mobile = store.getters.userInfo?.mobile
          if (!isValidPhone(mobile)) {
            sessionStorage.setItem('need_bind', 'true')
            next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
            return
          }
          next()
        } catch (error) {
          if (pathMatcher(whiteList, to.path)) {
            next()
          } else {
          }
        }
      }
    }
  } else {
    const code = getCodeFromUrl()

    if (code) {
      clearAuthParams()

      Toast.loading({
        message: '微信登录中...',
        forbidClick: true,
        duration: 0
      })

      try {
        const result = await store.dispatch('user/wechatLogin', code)
        // await store.dispatch('address/getList')
        Toast.clear()
        Toast.success('微信登录成功')

        if (result.needBind) {
          next(`/login?redirect=${encodeURIComponent(location.href)}`)
        } else {
          const redirect = to.query.redirect || '/user'
          next(redirect)
        }
        return
      } catch (error) {
        Toast.clear()
        Toast.fail(error.message || '微信登录失败')
        next('/login')
        return
      }
    }

    if (to.path === '/login') {
      next()
    } else if (pathMatcher(whiteList, to.path)) {
      console.log(to.path)
      next()
    } else {
      if (isWechatBrowser()) {
        const currentUrl = window.location.origin + '/mall/#/user'
        wechatSilentAuth(currentUrl)
      } else {
        next(`/login?redirect=${encodeURIComponent(location.href)}`)
      }
    }
  }
})

router.afterEach(() => {
  Toast.clear()
})
